import React from 'react';

import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import { useUserStatusContext } from '../../context/UserStatus';
import SearchForm, { SearchProps } from '../SearchForm';
import MenuNavbar from './MenuNavbar';
import OrgSwitcher from './OrgSwitcher';

export type HeaderProps = {
    additionalElement?: React.ReactNode;
    titleAddon?: React.ReactNode;
    title?: string;
} & SearchProps;

const Header: React.FC<HeaderProps> = ({
    additionalElement,
    title,
    titleAddon,
    ...searchProps
}) => {
    const { userStatus } = useUserStatusContext();

    return (
        <>
            <Section
                paddingTop="small"
                styles={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '2.4rem'
                }}
            >
                <MenuNavbar />
                {searchProps.searchLabel && (
                    <div style={{ width: '50%', display: 'flex', justifyContent: 'center' }}>
                        <SearchForm {...searchProps} />
                    </div>
                )}
                {userStatus?.hero_organization_id ? <OrgSwitcher /> : null}
            </Section>
            {title || additionalElement ? (
                <Section
                    paddingTop="none"
                    styles={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    {title && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1.2rem' }}>
                            <H noDefaultMargin role="h4">
                                {title}
                            </H>
                            {titleAddon}
                        </div>
                    )}
                    <Section
                        noDefaultPadding
                        styles={{ height: '5.2rem', display: 'flex', alignItems: 'center' }}
                    >
                        <div className="flex-center" style={{ gap: 'calc(var(--gutter)/2)' }}>
                            {additionalElement}
                        </div>
                    </Section>
                </Section>
            ) : null}
        </>
    );
};

export default Header;
